import { AlertCircle } from "lucide-react";

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@src/shared/components/ui/alert";

export function ErrorCareProtocolOpportunities() {
  return (
    <Alert
      variant="destructive"
      className="rounded-card border-destructive/40 bg-destructive/5 p-card"
    >
      <AlertCircle className="size-4" aria-hidden="true" />
      <AlertTitle>Unable to load upload history</AlertTitle>
      <AlertDescription>
        Something went wrong retrieving care gaps.
      </AlertDescription>
    </Alert>
  );
}
